import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page5() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let shayestegihayeOmoomi;
    if (JSON.parse(localStorage?.data)?.[jobId]?.shayestegihayeOmoomi) {
        shayestegihayeOmoomi = JSON.parse(localStorage?.data)?.[jobId]?.shayestegihayeOmoomi
    }else{
        shayestegihayeOmoomi = []
    }
    return (
        <Page pageNumber={14}>
            <div className="font-bold text-lg">
                شایستگی‌های عمومی:
            </div>
            <div className="flex flex-col">

                {
                    Object.keys(shayestegihayeOmoomi).sort(function (a, b) { return shayestegihayeOmoomi[b].value - shayestegihayeOmoomi[a].value }).map((key, index) => {
                        if (shayestegihayeOmoomi[key].value >= 3 && index < 21) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <div className="w-[60px] max-w-[60px] min-w-[60px] bg-gray-300 h-[10px] rounded">
                                        <div className="bg-[#5b5cff] h-[10px] rounded" style={{width:`${(((shayestegihayeOmoomi[key].value/5)*100)*60)/100}px`}}></div>
                                    </div>
                                    <div className="max-w-[120px] min-w-[120px] w-[120px] border-x-2 px-2">{key}</div>
                                    <div className="text-[13px]">{shayestegihayeOmoomi[key].desc}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}